import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import EngagementTypeService from "../../src/Services/EngagementType.service";
const EngagementTypeLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<EngagementType[]>' is not assignable to type '(ids: string[]) => Promise<EngagementType[]>'.
        fetchItemsById: (ids) => {
            return EngagementTypeService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return EngagementTypeService.searchAll(search);
        },
        optionRenderer: function optionRenderer(engagementType) {
            return _jsx("span", { children: engagementType.name });
        },
    });
};
export default EngagementTypeLookup;
